module.exports = __webpack_public_path__ + "img/home_my_value_02.9b7dd7ac.png";